import React from 'react';

interface LabelDetailCardProps {
  category: string; // dimension title (e.g., Root Causes)
  subcategory?: string; // taxonomy category name (e.g., Agent/Staff Member)
  title: string;
  reasoning?: string;
  regulation?: string;
  confidence?: number; // 0-100
  position?: { top: number; left: number };
}

const LabelDetailCard: React.FC<LabelDetailCardProps> = ({ category, subcategory, title, reasoning, regulation, confidence, position }) => {
  const pct = confidence !== undefined ? Math.round(confidence) : undefined;
  
  // Get category color
  const getCategoryColor = () => {
    switch (category.toLowerCase()) {
      case 'complaint declaration':
        return '#66aacc';
      case 'vulnerability':
        return '#7fd3fd';
      case 'customer strain':
        return '#904efd';
      case 'foreseeable harm':
        return '#741a3e';
      case 'root causes':
        return '#ffa9e7';
      case 'consumer duty':
        return '#0003ae';
      case 'financial impact':
        return '#904efd';
      default:
        return '#666666';
    }
  };
  
  return (
    <div 
      className="bg-white rounded-lg p-4 shadow-[0_4px_16px_rgba(0,0,0,0.15)] border border-[#e0e0e0] min-w-[320px] max-w-[400px]"
    >
      {/* Dimension Header */}
      <div className="text-[12px] font-semibold uppercase tracking-wide mb-2" style={{ color: getCategoryColor() }}>
        {category}
      </div>

      {/* Taxonomy Category (optional) */}
      {subcategory && (
        <div className="text-[11px] text-[#828282] mb-1">{subcategory}</div>
      )}
      
      {/* Label Title */}
      <div className="text-[16px] font-bold text-[#262628] mb-3">{title}</div>
      
      {/* Reasoning */}
      {reasoning && (
        <div className="text-[12px] text-[#262628] leading-[1.5] mb-3">{reasoning}</div>
      )}
      
      {/* Regulation */}
      {regulation && (
        <div className="mb-4">
          <div className="text-[10px] font-semibold text-[#828282] uppercase tracking-wide mb-1">Regulation</div>
          <div className="text-[12px] text-[#666666]">{regulation}</div>
        </div>
      )}
      
      {/* Confidence */}
      {pct !== undefined && (
        <div className="text-right">
          <div className="text-[11px] font-semibold text-[#262628] uppercase tracking-wide">
            CONFIDENCE
          </div>
          <div className="text-[16px] font-bold text-[#262628]">
            {pct}%
          </div>
        </div>
      )}
    </div>
  );
};

export default LabelDetailCard;
